<script>
export default {
  name: 'HomeLayout',
  render() {
    return this.$slots.default
  }
}
</script>
